export default {
    assets_url: process.env.VUE_APP_ASSETS_URL,
    api_url: process.env.VUE_APP_API_URL,
    public_url: process.env.VUE_APP_PUBLIC_API_URL,
    google_maps_api_key: process.env.VUE_APP_GOOGLE_MAP_API_KEY
};
